import * as React from 'react'
import { Navigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

const RedirectToInternalCompanyDocumentsListPage = () => {
  const { navigation } = useNavigation()
  const to = navigation.files.managementDocuments.list.fullPath()

  return <Navigate replace to={to} />
}

export default RedirectToInternalCompanyDocumentsListPage
